import Media from "./Media";
import TaggableData from "./TaggableData";
import InfoManager from "../managers/InfoManager";


export default class ObjectData extends TaggableData {

    constructor (objectData) {
        super(objectData);

        const object = Object.assign(this, objectData);
        object.mediaEntries = object.mediaEntries ? object.mediaEntries.map(item => new Media(item)) : [];

        object.mediaEntries.sort((a, b) => {
            // if (a.isSubTrack || b.isSubTrack) return 0;

            const list = InfoManager.systemLanguageList;
            let aWeight = list.includes(a.language) ? list.length - list.indexOf(a.language) : 0;
            let bWeight = list.includes(b.language) ? list.length - list.indexOf(b.language) : 0;

            if (aWeight === 0 && bWeight === 0) {
                if (a.language === 'en') aWeight = 1;
                if (b.language === 'en') bWeight = 1;
            }

            // return aWeight > bWeight ? 1 : (aWeight === bWeight ? 0 : -1);
            return bWeight - aWeight;
        });

        // Children list
        if (objectData.childrenList && objectData.childrenList.length > 0) {
            this.childrenList = objectData.childrenList
                .map(childData => {
                    if (!childData.objectId) return null;
                    return new ObjectData(childData);
                })
                .filter(it => !!it)

        }

        // Parent list
        if (objectData.parentList) {
            this.parentList = objectData.parentList
                .map(parentData => {
                    if (!parentData.objectId) return null;
                    return new ObjectData(parentData);
                })
                .filter(it => !!it);
        }

        // tracks hierarchy
        object.mediaEntries.forEach(media => {
            if (media.isSubTrack) {
                media.parent = object.mediaEntries.reduce((acc, cur) => {
                    return media.isChildOf(cur) ? cur : acc;
                }, null);
            } else {
                media.parent = object;
            }
        });

        // remove disabled medias
        object.mediaEntries = object.mediaEntries.filter(it => {
            return !(!it.isEnabled || !(!it.parent || it.parent.isEnabled));
        });

        return object;
    }

    objectId;

    get getDescription() {
        const optimalLang = InfoManager.systemLanguageList.find(l => !!this.tags[`Description_${l}`]);
        if (optimalLang) return this.tags[`Description_${optimalLang}`];

        if (this.tags.Description) return this.tags.Description
        if (this.tags.Description_en) return this.tags.Description_en;

        for (let tagName in this.tags) {
            if (tagName.includes('Description_')) return this.tags[tagName];
        }

        return "Unnamed";
    }

    get getLinks() {    // for Wiki, Youtube and etc ...
        return Object.keys(this.tags).filter((name) => {
            return name.indexOf('Url') > -1;
        }).map((name) => {
            return {
                name,
                value: this.tags[name]
            }
        });
    }

    get avatarImage() {
       let avatarMedia = this.mediaEntries.find(it => it.isMainAvatar);
       if (!avatarMedia) avatarMedia = this.mediaEntries.find(it => it.isAvatar);

       return avatarMedia ? avatarMedia.fileData : null;
    }

    get needUnlock() {
        return this.tags["NeedUnlock"] === "true"
    }

    get avatarId() {
       let avatarMedia = this.mediaEntries.find(it => it.isMainAvatar);
       if (!avatarMedia) avatarMedia = this.mediaEntries.find(it => it.isAvatar);

       return avatarMedia ? avatarMedia.mediaId : null;
    }

    get avatarList() {
        return this.mediaEntries.filter(it => it.isAvatar)
            .sort((a, b) => {
                if (a.isMainAvatar) return -1;
                if (b.isMainAvatar) return 1;
                return 0;
            });
    }

    get soundtrackList() {
        return this.mediaEntries.filter(it => it.isSpeak)
    }

    get relatedObjectMedias() {
        return this.mediaEntries
            .filter(it => it.tags.RelatedObjectId)
    }

    get parentObject() {
        return this.parentList && this.parentList[0]
            ? this.parentList[0]
            : null;
    }

    set parentObject(data) {
        this.parentList[0] = new ObjectData(data);
    }

    firstSpeek(selectedLanguage) {

        if (this.mediaEntries.length < 1) {
            return null;
        }

        if (selectedLanguage) {
            return this.mediaEntries
                .filter(it => it.isSpeak)
                .find(it => !it.isSubTrack && it.language === selectedLanguage);
        }

        const lang = InfoManager.systemLanguageList.find(l => !!this.firstSpeek(l));

        return lang ? this.firstSpeek(lang) : null;
    }

    firstSpeekNode(selectedLanguage) {
        let speek = this.firstSpeek(selectedLanguage);

        if (!speek) {
            speek = this.mediaEntries.find(it => it.isSpeak && !it.isSubTrack);
        }

        if (!speek || !speek.parent || !speek.parent.mediaEntries) return null;

        const children = Media.sortByPrefPrevTag(speek.parent.mediaEntries.filter(item => item && item.isSpeak && item.isChildOf(speek)));

        return [speek, ...children]
    }

    relatedObjectList;
    mediaEntries;
    parentList = [];
    childrenList;

    description(selectedLanguage) {
        return this.tags[`Description_${selectedLanguage}`] || this.getDescription;
    }

    get languageList() {

        const descLangList = Object.keys(this.tags).reduce((acc, key) => {
            if (key.indexOf('Description_') > -1) {
                const lang = key.split('_')[1];
                acc.push(lang);
            }

            return acc;
        }, []);

        const tracksLangList = this.mediaEntries.reduce((acc, track) => {

            if (track.tags.Language && track.tags.Language.length === 2) {
                acc.push(track.tags.Language);
            }

            return acc;
        }, []);

        return Array.from(new Set([...descLangList, ...tracksLangList]));
    }

    get isContainerObject() {
        return true;
        // return false;
        // return this.mediaEntries.length === 0
    }

    get comment() {
        return this.tags.Comment || ""
    }

}
